module.exports = __webpack_public_path__ + "img/livewire.ae4d060a.png";